import { useEffect, useState } from 'react';
import Lupita from '../../assets/iconos/lupa.png';
import ProfilePic from '../../assets/iconos/perf360.svg'
import { serachByName } from '../../Services/User.js';
import { sendFriendRequest } from '../../Services/Inbox.js';

import DialogModal from '../Modals/dialogModal';

const Search = () => {

    const [users, setUsers] = useState(null);
    const [searchName, setSearchName] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [modalMsg, setModalMsg] = useState()

    const searchUserByName = async () => {
        let rsp = await serachByName(searchName);

        if(rsp.Error == false && rsp.Data.length > 0){
            setUsers(rsp.Data);
        }
    }

    const submitRequest = async (id) => {

        let rsp = await sendFriendRequest(id);

        if(rsp.Error == false){
            setShowModal(true);
            setModalMsg('Solicitud enviada correctamente');
        }else{
            setShowModal(true);
           setModalMsg(rsp.Message || 'Intente mas tarde.');
        }
    }

    useEffect(() => {
        searchUserByName();
    }, [])


    return(
        <>
            <div className="chat-search">
                    <input type="text" placeholder="Buscar por nombre" className="search-field" onChange={e => setSearchName(e.target.value)}/>
                    <img src={Lupita} alt="search button" className="search-button setpointer sethoverdark" onClick={searchUserByName}/>
            </div>
            {
                users != null ?
                <>
                    {
                        users.map(item => {
                            return(
                                <div  className='chat-card setpointer' key={item.id + 'usrS'}> 
                                    <div className='chat-picture'>
                                        <img src={item.url_profile_pic} alt="contact-picture" className='chat-pic'/>
                                    </div>
                                    <div className='contact-info'>
                                        <div className='contact-name'>
                                            <h4>{item.name}</h4>
                                        </div>
                                        <div>
                                            <h6>DNI: {item.dni}</h6>
                                        </div>
                                    </div>
                                    <button className='green-btn sethoverdark setpointer' onClick={() => submitRequest(item.id)} id={item.id}>Enviar Solicitud</button>
                                </div>
                            );
                        })
                    }
                </>
                :
                <></>
            }
            <DialogModal showModal={showModal} setShowModal={setShowModal}>
                <h3>{modalMsg}</h3>
            </DialogModal>
        </>
    )
}

export default Search;